import React from 'react';
import './Card.css';
import image from '../../assets/computer-icon.svg';
import arrow from '../../assets/arrow-card.svg';

function Card({text, title}) {
    return (
        <div className="card__main">
            <div className="card__body">
                <div className="card__icon">
                    <img src={image} alt="" />
                </div>
                <div className="head__three">
                {title}
                </div>
                <div className="card__text">
                {text}
                </div>
            </div>
            <div className="card__arrow">
                <img src={arrow} alt="" />
            </div>
        </div>
    )
}

export default Card
